import { media, T2, T2Props } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledContainerDiv = styled.div`
  display: flex;
  margin-bottom: -1px;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
  `}
`;

export const StyledLeftDiv = styled.div`
  min-width: 60px;
  max-width: 60px;
  margin-right: 20px;
`;

export const StyledRightDiv = styled.div <{ isLongTitle: boolean }>`
  width:100%;
  margin-top: 14px;

  ${media.sm`
    margin-top: 17px;
  `}

  ${({ isLongTitle }) => isLongTitle && media.sm`
    margin-top: 3px;
  `}
`;

export const StyledContentDiv = styled.div`
  padding-top: 19px;
`;

export const StyledTitle = styled<FC<T2Props>>(T2)`
  margin-bottom: 0px;
  color:inherit;
  font-weight: 800;
  line-height: 1.17;

  ${media.sm`
    padding-top: 0;
  `}
`;
